import { createCustomEnum } from "./customEnum";

const UWDecisions = createCustomEnum({
	Approved: {
		value: 1,
		name: "approved",
		displayName: "Approved",
	},
	ApprovedNeedsSponsorBankConcurrence: {
		value: 2,
		name: "approved.needs_sponsor_bank_concurrence",
		displayName: "Approved: Needs sponsor bank concurrence",
	},
	ApprovedWithConditions: {
		value: 3,
		name: "approved.with_conditions",
		displayName: "Approved: With conditions",
	},
	DeclinedDoesNotMeetJurisdictionReqs: {
		value: 4,
		name: "declined.doesnt_meet_jurisdiction_reqs",
		displayName: "Declined: Doesn't meet jurisdiction reqs",
	},
	DeclinedExcessFinRisk: {
		value: 5,
		name: "declined.excess_fin_risk",
		displayName: "Declined: Excess Fin Risk",
	},
	DeclinedExcessRisk: {
		value: 6,
		name: "declined.excess_risk",
		displayName: "Declined: Excess Risk",
	},
	DeclinedExistingPriorAuroraIssue: {
		value: 7,
		name: "declined.existing_prior_aurora_issue",
		displayName: "Declined: Existing/ Prior Aurora issue",
	},
	DeclinedGofacListing: {
		value: 8,
		name: "declined.gofac_listing",
		displayName: "Declined: Gofac listing",
	},
	DeclinedMatchListing: {
		value: 9,
		name: "declined.match_listing",
		displayName: "Declined: Match listing",
	},
	DeclinedOpenBankruptcy: {
		value: 10,
		name: "declined.open_bankruptcy",
		displayName: "Declined: Open Bankruptcy",
	},
	DeclinedOther: {
		value: 11,
		name: "declined.other",
		displayName: "Declined: Other",
	},
	DeclinedSuspicious: {
		value: 12,
		name: "declined.suspicious",
		displayName: "Declined: Suspicious",
	},
	DeclinedUnableToValidateBusiness: {
		value: 13,
		name: "declined.unable_to_validate_business",
		displayName: "Declined: Unable to validate business",
	},
	DeclinedUnableToValidatePrincipals: {
		value: 14,
		name: "declined.unable_to_validate_principals",
		displayName: "Declined: Unable to validate principal(s)",
	},
	DeclinedUnacceptableBusinessType: {
		value: 15,
		name: "declined.unacceptable_business_type",
		displayName: "Declined: Unacceptable business type",
	},
	DeclinedUnsatisfactoryCredit: {
		value: 16,
		name: "declined.unsatisfactory_credit",
		displayName: "Declined: Unsatisfactory credit",
	},
	DeclinedUnsatisfactoryProcessingHistory: {
		value: 17,
		name: "declined.unsatisfactory_processing_history",
		displayName: "Declined: Unsatisfactory processing history",
	},
	AutoApproved: {
		value: 18,
		name: "auto_approved",
		displayName: "Auto Approved",
	},
	AutoDeclineFourteenDays: {
		value: 19,
		name: "auto_decline_fourteen_days",
		displayName: "Auto-decline 14 days",
	},
});

export default UWDecisions;

export const uwApproveDecisions = [
	UWDecisions.Approved,
	UWDecisions.ApprovedNeedsSponsorBankConcurrence,
	UWDecisions.ApprovedWithConditions,
];
export const uwDeclineDecisions = [
	UWDecisions.DeclinedDoesNotMeetJurisdictionReqs,
	UWDecisions.DeclinedExcessFinRisk,
	UWDecisions.DeclinedExcessRisk,
	UWDecisions.DeclinedExistingPriorAuroraIssue,
	UWDecisions.DeclinedGofacListing,
	UWDecisions.DeclinedMatchListing,
	UWDecisions.DeclinedOpenBankruptcy,
	UWDecisions.DeclinedOther,
	UWDecisions.DeclinedSuspicious,
	UWDecisions.DeclinedUnableToValidateBusiness,
	UWDecisions.DeclinedUnableToValidatePrincipals,
	UWDecisions.DeclinedUnacceptableBusinessType,
	UWDecisions.DeclinedUnsatisfactoryCredit,
	UWDecisions.DeclinedUnsatisfactoryProcessingHistory,
];
export const uwQaCompleteDecisions = [UWDecisions.Approved];
